// extracted by mini-css-extract-plugin
export default {"chartPlaceHolder":"Parking_chartPlaceHolder__jEJET","chartLegend":"Parking_chartLegend__eU8Us"};